import * as React from 'react';
import { Select as AntdSelect } from 'antd';
import Icon from '../Icon';
const { Option } = AntdSelect;
import { SelectProps as AntdSelectProps } from 'antd/lib/select';
import { AppContext } from '@/utils/appProvider';
import classnames from 'classnames';
import './index.less';

export interface SelectOption {
  label: string;
  value: string;
  disabled?: boolean;
}
export interface SelectProps extends AntdSelectProps<any> {
  options?: SelectOption[];
  defaultValue?: string;
}

const Select: React.FC<SelectProps> = (props) => {
  const { children, className, options, defaultValue, ...rest } = props;
  const { prefixCls } = React.useContext(AppContext);

  return (
    <AntdSelect
      className={classnames(`${prefixCls}-select`, className)}
      suffixIcon={<Icon name="icon-caret_down" />}
      dropdownClassName={`${prefixCls}-select-dropdown`}
      defaultValue={defaultValue}
      notFoundContent={<span className={`${prefixCls}-select-dropdown-empty`}>暂无数据</span>}
      {...rest}
    >
      {options
        ? options.map((item) => {
            return (
              <Option key={item.value} disabled={item.disabled} value={item.value}>
                {item.label}
              </Option>
            );
          })
        : children}
    </AntdSelect>
  );
};

export default Select;
